import DOMPurify from "dompurify";

/**
 * DOMPurify config — allow the rich-text output we produce
 * (headings, links, images, lists, formatting) while stripping any
 * scripts / event handlers / dangerous protocols.
 */
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "hr",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "strong", "b", "em", "i", "u", "s", "sub", "sup",
    "ul", "ol", "li",
    "blockquote", "code", "pre",
    "a", "img",
    "span", "div",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel",
    "src", "alt", "title",
    "class",
  ],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data:image\/):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
};

/** Sanitize an HTML string for safe insertion into the DOM. */
export function sanitizeHtml(dirty) {
  if (!dirty) return "";
  return DOMPurify.sanitize(dirty, CONFIG);
}

/** Convert (possibly untrusted) HTML to plain text — safely.
 *  Uses DOMParser (no scripts execute) and drops <script>/<style>
 *  subtrees so their source doesn't leak into visible text. */
export function htmlToPlainText(dirty) {
  if (!dirty) return "";
  const doc = new DOMParser().parseFromString(String(dirty), "text/html");
  doc.querySelectorAll("script, style, noscript").forEach((n) => n.remove());
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
}
